import React from "react";
import "./PendingJobFormLogDetails.css";

import { Dialog, DialogContent, DialogTitle, TextField } from "@mui/material";

import { convertToPSTWithSeconds } from "../../../../constants/dateTime";

const notApplicable = "N/A";

const displayValue = (value) => {
	if (value === null || value === undefined || value === "") return notApplicable;
	return value;
};

const displayDate = (value) => {
	if (!value) return notApplicable;
	return convertToPSTWithSeconds(value);
};

const PendingJobFormLogDetails = (props) => {
	const r = props.recordToView ?? {};

	const formClosed = () => {
		props.setOpen(false);
	};

	return (
		<Dialog
			id="pendingJobFormLogDetailsDialog"
			open={props.open}
			fullWidth
			maxWidth="lg"
			onClose={formClosed}
		>
			<DialogTitle id="pendingJobFormLogDetailsDialogTitle">
				Pending Job Form Log Details
			</DialogTitle>
			<DialogContent id="pendingJobFormLogDetailsDialogContent">
				<div className="pendingJobFormLogDetailsDialogRow">
					<TextField
						sx={{ flex: 1 }}
						label="Log ID"
						value={displayValue(r.id)}
						InputProps={{ readOnly: true }}
					/>
					<TextField
						sx={{ flex: 1 }}
						label="Action Type"
						value={displayValue(r.action_type)}
						InputProps={{ readOnly: true }}
					/>
					<TextField
						sx={{ flex: 1 }}
						label="Action Status"
						value={displayValue(r.action_status)}
						InputProps={{ readOnly: true }}
					/>
				</div>
				<div className="pendingJobFormLogDetailsDialogRow">
					<TextField
						sx={{ flex: 1 }}
						label="Action Clicked"
						value={displayDate(r.action_clicked_time)}
						InputProps={{ readOnly: true }}
					/>
					<TextField
						sx={{ flex: 1 }}
						label="Action Completed"
						value={displayDate(r.action_completed_time)}
						InputProps={{ readOnly: true }}
					/>
					<TextField
						sx={{ flex: 1 }}
						label="Submitted By"
						value={displayValue(
							r.submitted_by_employee_name ||
								r.submitted_by_employee_name_lookup
						)}
						InputProps={{ readOnly: true }}
					/>
				</div>
				<div className="pendingJobFormLogDetailsDialogRow">
					<TextField
						sx={{ flex: 1 }}
						label="Pending Job ID"
						value={displayValue(r.pending_job_id)}
						InputProps={{ readOnly: true }}
					/>
					<TextField
						sx={{ flex: 2 }}
						label="Property Name"
						value={displayValue(r.property_name)}
						InputProps={{ readOnly: true }}
					/>
					<TextField
						sx={{ flex: 2 }}
						label="Project Name"
						value={displayValue(r.project_name)}
						InputProps={{ readOnly: true }}
					/>
				</div>
				<div className="pendingJobFormLogDetailsDialogRow">
					<TextField
						sx={{ flex: 1 }}
						label="Deal Owner ID"
						value={displayValue(r.deal_owner_id)}
						InputProps={{ readOnly: true }}
					/>
					<TextField
						sx={{ flex: 1 }}
						label="BQE Property ID"
						value={displayValue(r.bqe_property_id)}
						InputProps={{ readOnly: true }}
					/>
					<TextField
						sx={{ flex: 1 }}
						label="BQE Project ID"
						value={displayValue(r.bqe_project_id)}
						InputProps={{ readOnly: true }}
					/>
				</div>
				<div className="pendingJobFormLogDetailsDialogRow">
					<TextField
						sx={{ flex: 1 }}
						label="Created Property ID"
						value={displayValue(r.created_property_id)}
						InputProps={{ readOnly: true }}
					/>
					<TextField
						sx={{ flex: 1 }}
						label="Created Project ID"
						value={displayValue(r.created_project_id)}
						InputProps={{ readOnly: true }}
					/>
					<TextField
						sx={{ flex: 1 }}
						label="Created Phase 1 ID"
						value={displayValue(r.created_phase1_id)}
						InputProps={{ readOnly: true }}
					/>
				</div>
				<div className="pendingJobFormLogDetailsDialogRow">
					<TextField
						sx={{ flex: 1 }}
						label="Created Phase 2 ID"
						value={displayValue(r.created_phase2_id)}
						InputProps={{ readOnly: true }}
					/>
					<TextField
						sx={{ flex: 1 }}
						label="Created Phase 3 ID"
						value={displayValue(r.created_phase3_id)}
						InputProps={{ readOnly: true }}
					/>
					<TextField
						sx={{ flex: 1 }}
						label="Created Phase 4 ID"
						value={displayValue(r.created_phase4_id)}
						InputProps={{ readOnly: true }}
					/>
				</div>
				<div className="pendingJobFormLogDetailsDialogRow">
					<TextField
						sx={{ flex: 1 }}
						label="Error Message"
						value={displayValue(r.error_message)}
						InputProps={{ readOnly: true }}
					/>
				</div>
				<div className="pendingJobFormLogDetailsDialogRow">
					<TextField
						sx={{ flex: 1 }}
						label="Payload JSON"
						value={displayValue(r.payload_json)}
						multiline
						minRows={10}
						InputProps={{ readOnly: true }}
					/>
				</div>
			</DialogContent>
		</Dialog>
	);
};

export default PendingJobFormLogDetails;
